import { memo, useEffect, useState } from "react";
import "../index.scss";
import CustomScroll from "@src/component/customScroll";
import { preSubmitInsured } from "@src/service/ownService";
import { Toast } from "antd-mobile";
import { goto } from "@src/route";
import { getConfigByKey } from '@src/util'
const ApplyInfo = (props: any) => {

  const { userInfo } = props;

  const [userData, setUser] = useState<any>();
  const [showBtn, setShowBtn] = useState<boolean>(false);
  useEffect(() => {
    userInfo && setUser(userInfo);
  }, [userInfo])

  // 判断是否该出现按钮
  useEffect(()=>{
    preSubmitInsured().then(()=>{
      setShowBtn(true)
    }).catch((err)=>{console.log(err)})
  }, [])

  /**
   * 判断是否能去分期申请页面
   */
  const toBankCard = async () => {
    try {
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false
      })
      const res: any = await preSubmitInsured();
      Toast.clear()
      goto(`/apply/w1?loanId=${res.loanId ? encodeURIComponent(res.loanId) : ''}&no=${res.no as string}`);
    } catch (err: any) {
      Toast.show(err?.errmsg || '请求失败');
    }
  }

  // 注解关系
  const gxLabel = (key: number | string) => {
    if (getConfigByKey("gx")?.length) {
      return getConfigByKey("gx").find((res: any) => res.value == key)?.label
    }
    return ''
  }

  // 注解学历
  const xlLabel = (key: number | string) => {
    if (!key) {
      return '其他'
    }
    if (isNaN(Number(key))) {
      return key
    }
    if (getConfigByKey("xl")?.length) {
      return getConfigByKey("xl").find((res: any) => res.value == key)?.label
    }
    return '其他'
  }

  return (<div className="page bottomFit ApplyInfo">
    <CustomScroll>
      <div>
        <div className="info-box">
          <h2 className="dotted-line">身份信息</h2>
          <ul>
            <li>
              <label>还款银行卡：</label>
              <span>{userInfo?.loanBank?.accountNo}</span>
            </li>
            <li>
              <label>开户银行：</label>
              <span>{userInfo?.loanBank?.bankName}</span>
            </li>
            <li>
              <label>姓名：</label>
              <span>{userInfo?.loanInsured?.name}</span>
            </li>
            <li>
              <label>手机号码：</label>
              <span>{userInfo?.loanInsured?.mobile}</span>
            </li>
            <li>
              <label>身份证号码：</label>
              <span>{userInfo?.loanInsured?.identifyNumber}</span>
            </li>
            <li>
              <label>身份证地址：</label>
              <span>{userInfo?.loanInsured?.identifyAddress}</span>
            </li>
            <li>
              <label>学历：</label>
              <span>{xlLabel(userInfo?.loanInsured?.education || userInfo?.qualification?.education)}</span>
            </li>
          </ul>
        </div>
        <div className="info-box">
          <h2 className="dotted-line">基本信息</h2>
          <ul>
            <li>
              <label>申请人邮箱：</label>
              <span>{userInfo?.loanInsured?.email}</span>
            </li>
            <li>
              <label>现住址：</label>
              <span>{userInfo?.loanInsured?.addressProvince}{userInfo?.loanInsured?.addressCity}{userInfo?.loanInsured?.addressCounty}</span>
            </li>
            <li>
              <label>现住详细地址：</label>
              <span>{userInfo?.loanInsured?.addressDetail}</span>
            </li>
          </ul>
        </div>
        <div className="info-box">
          <h2 className="dotted-line">申请人工作信息</h2>
          <ul>
            <li>
              <label>单位名称：</label>
              <span>{userInfo?.loanInsured?.uint}</span>
            </li>
            <li>
              <label>单位地址：</label>
              <span>{userInfo?.loanInsured?.unitAddressProvince}{userInfo?.loanInsured?.unitAddressCity}{userInfo?.loanInsured?.unitAddressCounty}</span>
            </li>
            <li>
              <label>单位详细地址：</label>
              <span>{userInfo?.loanInsured?.unitAddress}</span>
            </li>
            <li>
              <label>单位电话：</label>
              <span>{userInfo?.loanInsured?.unitPhoneNumber}</span>
            </li>
          </ul>
        </div>
        {userData?.loanInsured?.liaisons.map((itemL: any, indexL: number) => (
          <div key={indexL} className="info-box">
            {indexL == 0 && <h2 className="dotted-line">紧急联系人信息</h2>}
            <ul>
              <li>
                <label>与本人关系：</label>
                <span>{gxLabel(itemL?.relation)}</span>
              </li>
              <li>
                <label>联系人姓名：</label>
                <span>{itemL?.name}</span>
              </li>
              <li>
                <label>手机号码：</label>
                <span>{itemL?.mobile}</span>
              </li>
              {itemL?.relation == 2 && <li>
                <label>单位名称：</label>
                <span>{itemL?.uint}</span>
              </li>}
            </ul>
          </div>))}
        <div className="info-box">
          <h2 className="dotted-line">车辆信息</h2>
          <ul>
            <li>
              <label>经销商名称：</label>
              <span>{userInfo?.loanCar?.carDealerName}</span>
            </li>
            <li>
              <label>车型名称：</label>
              <span>{userInfo?.loanCar?.vehicleName}</span>
            </li>
            <li>
              <label>裸车价：</label>
              <span>{userInfo?.loanCar?.netPrice || 0}元</span>
            </li>
            <li>
              <label>车辆是否登记本人：</label>
              <span>{userInfo?.loanCar?.isSelf == 1 ? '是' : '否'}</span>
            </li>
            {userInfo?.loanCar?.isSelf === 0 && <>
              <li>
                <label>背户类型：</label>
                <span>{userInfo?.loanCar?.type == 1 ? '个人' : '公司'}</span>
              </li>
              {userInfo?.loanCar?.type == 2 && <li>
                <label>背户公司名称：</label>
                <span>{userInfo?.loanCar?.company}</span>
              </li>}
              {userInfo?.loanCar?.type == 1 && <>
                <li>
                  <label>背户人姓名：</label>
                  <span>{userInfo?.loanCar?.name}</span>
                </li>
                <li>
                  <label>背户人身份证：</label>
                  <span>{userInfo?.loanCar?.identifyNumber}</span>
                </li>
                <li>
                  <label>背户人手机号码：</label>
                  <span>{userInfo?.loanCar?.mobile}</span>
                </li>
              </>}
            </>}
          </ul>
        </div>
        <div className="info-box">
          <h2 className="dotted-line">分期信息</h2>
          <ul>
            {/* <li>
              <label>是否分期盗抢权益：</label>
              <span>{userInfo?.loanCar?.carDealerName}</span>
            </li> */}
            <li>
              <label>是否分期购置税：</label>
              <span>{userInfo?.loanCar?.taxAmount>0?'是':'否'}</span>
            </li>
            {userInfo?.loanCar?.taxAmount>0&&<li>
              <label>购置税款：</label>
              <span>{userInfo?.loanCar?.taxAmount || 0}元</span>
            </li>}
            <li>
              <label>首付比例：</label>
              <span>{userInfo?.loanCar?.firstPaidRate?`${(userInfo?.loanCar?.firstPaidRate * 100).toFixed(0)}%`: '0%'}</span>
            </li>
            <li>
              <label>自付车款金额：</label>
              <span>{userInfo?.loanCar?.selfPayAmount || 0}元</span>
            </li>
            <li>
              <label>分期期数：</label>
              <span>{userInfo?.loanCar?.periods?`${userInfo?.loanCar?.periods as string}期`:''}</span>
            </li>
            <li>
              <label>实际申请分期金额：</label>
              <span>{userInfo?.loanCar?.amount || 0}元</span>
            </li>
          </ul>
        </div>
      </div>
      {showBtn&&<div onClick={toBankCard} className="button-them editBtn">去编辑</div>}
    </CustomScroll>
  </div>)
}

export default memo(ApplyInfo);